  <div class="signup-container">
    <app-menu headerCSS="bg-dark"></app-menu>
  </div>
  <div class="header-inner bg-light text-center">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2 class="text-primary">Register</h2>
          <ol class="breadcrumb mb-0 p-0">
            <li class="breadcrumb-item"><a href="index.html"> Home </a></li>
            <li class="breadcrumb-item active"> <i class="fas fa-chevron-right"></i> <span> Register </span></li>
          </ol>
        </div>
      </div>
    </div>
  </div>
  <app-signup-form></app-signup-form>
  <app-footer></app-footer>
